module.exports = __webpack_public_path__ + "img/UTBEAR-4.53d443cc.jpg";